import { ELoginSource } from '@webtrader/core/api/user/types';

export const getLoginSource = (os: string): ELoginSource => {
  if (os === 'android') {
    return ELoginSource.ANDROID_APP;
  }
  if (os === 'web') {
    return ELoginSource.MOBILE_WEB;
  }
  return ELoginSource.IOS_APP;
};
